import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authapi from "../../services/auth";

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ uniqueValue, password }, { rejectWithValue }) => {
    try {
      const response = await authapi.post("Auth/Token", { uniqueValue, password });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.ExceptionMessage || error.response.data.message || "Giriş işlemi başarısız.");
      }
      return rejectWithValue("Bağlantı hatası veya sunucuya ulaşılamıyor.");
    }
  }
);

export const verifyTwoFactor = createAsyncThunk(
  "auth/verifyTwoFactor",
  async ({ userId, code }, { rejectWithValue }) => {
    try {
      const response = await authapi.post("Auth/two-factor", { userId, code });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.ExceptionMessage || error.response.data.message || "Doğrulama işlemi başarısız.");
      }
      return rejectWithValue("Bağlantı hatası veya sunucuya ulaşılamıyor.");
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  successMessage: null,
  requiresTwoFactor: false,
  tempUserId: null,
  token: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;
    },
    resetAuth: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      // loginUser
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        const resData = action.payload;
        
        state.successMessage = resData.message;
        
        if (resData.isTwoFactorEnabled) {
          state.requiresTwoFactor = true;
          state.tempUserId = resData.data.UserId;
        } else {
          state.requiresTwoFactor = false;
          state.token = resData.data.Token;
          state.tempUserId = null;
        }
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // verifyTwoFactor
      .addCase(verifyTwoFactor.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(verifyTwoFactor.fulfilled, (state, action) => {
        state.loading = false;
        const resData = action.payload;
        
        state.successMessage = resData.message;
        state.requiresTwoFactor = false;
        state.token = resData.data.Token;
        state.tempUserId = null;
      })
      .addCase(verifyTwoFactor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, resetAuth } = authSlice.actions;
export default authSlice.reducer;
